import type { NodeType } from '../data/schema'

interface TypeIconProps {
  type: NodeType
  size?: number
  className?: string
}

const iconMarkup: Record<NodeType, string> = {
  deity: '<circle cx="12" cy="12" r="3.4"/><path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5.3 5.3l2.1 2.1M16.6 16.6l2.1 2.1M18.7 5.3l-2.1 2.1M7.4 16.6l-2.1 2.1"/>',
  hero: '<path d="m12 3.2 2.7 5.4 6 .9-4.4 4.2 1.1 6-5.4-2.9-5.4 2.9 1.1-6-4.4-4.2 6-.9Z"/>',
  mortal: '<circle cx="12" cy="8" r="3.2"/><path d="M5.5 20c.8-4.1 3-6.2 6.5-6.2s5.7 2.1 6.5 6.2"/>',
  creature: '<path d="M6.3 7.8 3.8 4.5c3.1-.2 5.1.8 6 3M17.7 7.8l2.5-3.3c-3.1-.2-5.1.8-6 3"/><path d="M5.7 8.5c1.4-1.5 3.5-2.3 6.3-2.3s4.9.8 6.3 2.3l-1.1 7.8L12 20l-5.2-3.7Z"/><path d="M8.4 11.5h.1M15.5 11.5h.1M9.7 16h4.6"/>',
  place: '<path d="m3.5 19 5.8-9 2.5 3.4 3.3-5.2L20.5 19Z"/><path d="M7 19h11"/>',
  event: '<path d="m12 2.8 1.5 6 5.7 1.5-5.7 1.5-1.5 6-1.5-6-5.7-1.5 5.7-1.5Z"/><path d="m18.8 16 .6 2.2 2.1.6-2.1.6-.6 2.1-.6-2.1-2.2-.6 2.2-.6Z"/>',
  artifact: '<path d="M6 4.5h12v4H6zM8 8.5h8v11H8z"/><path d="M10 12h4M10 15h4"/>',
}

export function TypeIcon({ type, size = 16, className }: TypeIconProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      data-symbol={type === 'hero' ? 'star' : type}
      dangerouslySetInnerHTML={{ __html: iconMarkup[type] }}
    />
  )
}

const typeColors: Record<NodeType, string> = {
  deity: '#D6A647',
  hero: '#4D8FCC',
  mortal: '#CDAE79',
  creature: '#CF6F5C',
  place: '#4F9A78',
  event: '#8C69A8',
  artifact: '#C58A45',
}

export function typeIconDataUri(type: NodeType) {
  const svg = `<?xml version="1.0" encoding="UTF-8"?><!DOCTYPE svg><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><circle cx="9" cy="9" r="8" fill="${typeColors[type]}" stroke="#FFF0B7" stroke-width="1"/><g transform="translate(3.6 3.6) scale(.45)" fill="none" stroke="#08111C" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">${iconMarkup[type]}</g></svg>`
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`
}
